export const createGuid = () => {
  const unique = (l) => Math.random().toString(16).slice(2, l);

  return `${unique(10)}-${unique(6)}-${unique(6)}-${unique(6)}-${unique(14)}`;
};
